(() => {
  'use strict';
  const panel = document.querySelector('[data-workspace-analytics]');
  if (!panel || panel.dataset.initialized === 'true') return;
  panel.dataset.initialized = 'true';
  const status = panel.querySelector('[data-analytics-status]');
  const buttons = panel.querySelectorAll('[data-analytics-choice]');
  const privacySignal = () => navigator.globalPrivacyControl === true || navigator.doNotTrack === '1';
  const pages = {index: '/', product: '/products', collection: '/collections', list_collections: '/collections', blog: '/blog', article: '/article', page: '/pages', policy: '/policies'};
  let ready = false, sent = false, saving = false;
  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
  const preview = () => !window.Shopify || window.Shopify.designMode || !window.Shopify.theme || window.Shopify.theme.role !== 'main' || new URL(location.href).searchParams.has('preview_theme_id');
  const allowed = () => {
    try { return ready && !privacySignal() && privacy().analyticsProcessingAllowed() === true && privacy().currentVisitorConsent().analytics === 'yes'; }
    catch { return false; }
  };
  const referrer = () => {
    try {
      const host = new URL(document.referrer).hostname;
      if (/(^|\.)(google\.[a-z.]+|bing.com|duckduckgo.com)$/.test(host)) return 'search';
      if (/(^|\.)(facebook.com|instagram.com|t.co|linkedin.com|tiktok.com)$/.test(host)) return 'social';
      return host === 'tedtesting.app' ? 'workspace' : 'external';
    } catch { return 'direct'; }
  };
  const send = () => {
    const page = pages[panel.dataset.pageType];
    if (sent || saving || !page || preview() || !allowed() || !['https://paintmelike.co', 'https://www.paintmelike.co'].includes(location.origin)) return;
    sent = true;
    const medium = new URL(location.href).searchParams.get('utm_medium');
    fetch('https://tedtesting.app/public/visit', {
      method: 'POST', mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer', keepalive: true,
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({consent: 'analytics-v1', page, referrer: referrer(), campaign: ['email', 'social', 'search', 'referral'].includes(medium) ? medium : 'none'}),
    }).catch(() => {});
  };
  const render = () => {
    status.textContent = privacySignal() ? 'Your browser privacy signal disables this optional measurement.'
      : !ready ? 'Optional measurement is off while privacy settings are unavailable.'
      : allowed() ? 'Your store analytics preference is on.' : 'Optional measurement is off.';
    buttons.forEach(button => { button.disabled = !ready || saving || (button.dataset.analyticsChoice === 'allow' && privacySignal()); });
  };
  panel.addEventListener('click', event => {
    const choice = event.target.dataset.analyticsChoice;
    if (!['allow', 'deny'].includes(choice) || !ready || saving || (choice === 'allow' && privacySignal())) return;
    saving = true; render();
    try {
      // Change only analytics, only after the visitor clicks. Shopify owns persistence.
      privacy().setTrackingConsent({analytics: choice === 'allow'}, error => {
        saving = false;
        render();
        if (error) { status.textContent = 'Could not save your preference. Please try again.'; return; }
        send();
      });
    } catch { saving = false; render(); status.textContent = 'Could not save your preference. Please try again.'; }
  });
  document.addEventListener('visitorConsentCollected', () => { render(); send(); });
  const apiReady = () => {
    const api = privacy();
    return !!api && ['analyticsProcessingAllowed', 'currentVisitorConsent', 'setTrackingConsent'].every(name => typeof api[name] === 'function');
  };
  let attempts = 0, loading = false;
  const initialize = () => {
    if (apiReady()) { ready = true; render(); send(); return; }
    if (++attempts > 50) { render(); return; }
    if (!loading && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loading = true;
      try {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], () => {
          if (apiReady()) { ready = true; render(); send(); }
        });
      } catch { /* Unavailable privacy API leaves collection off. */ }
    }
    if (!ready) setTimeout(initialize, 100);
  };
  render(); initialize();
})();
